import johnDoe from '../assets/img/testim1.jpg';
import priscilla from '../assets/img/testim2.jpg';
import luke from '../assets/img/testim3.jpg';
import joy from '../assets/img/joyful-lady-small.jpg';

export const TESTIMONIALS = [
    {
        id: 0,
        author: 'John Doe',
        image: johnDoe,
        star: 5,
        description:
            'Nestled in the foothills of the Chrome Mountains, this campground on the shores of the pristine React Lake is a favorite for fly fishers.',
        position: 'Software Engineer'
    },
    {
        id: 1,
        author: 'Priscilla Thom',
        image: priscilla,
        star:4,
        description:
            'Spend a few sunny days and starry nights beneath a canopy of old-growth firs at this enchanting spot by the Chrome River.',
        position:'Project Manager'
    },
    {
        id: 2,
        author: 'Luke John',
        image: luke,
        star:3,
        description:
            'Let NuCamp be your guide to this off-the-beaten-path, hike-in-only campground.',
        position:'Business Analyst'
    },
    {
        id: 3,
        author: 'Jane Dodo',
        image: joy,
        star:3,
        description:
            'Let NuCamp be your guide to this off-the-beaten-path, hike-in-only campground.',
        position: 'Tech Support'
    },
    {
        id: 4,
        author: 'Mike Wick',
        image: johnDoe,
        star:4,
        description:
            'Let NuCamp be your guide to this off-the-beaten-path, hike-in-only campground.',
        position: 'Sharepoint Developer'
    },
    {
        id: 5,
        author: 'Mooke Lance',
        image: priscilla,
        star:5,
        description:
            'Let NuCamp be your guide to this off-the-beaten-path, hike-in-only campground.',
        position: 'Water Surfer'
    },
    {
        id: 6,
        author: 'Tomi Benson',
        image: joy,
        star:4,
        description:
            'Let NuCamp be your guide to this off-the-beaten-path, hike-in-only campground.',
        position:'Athlete'
    },
    {
        id: 7,
        author: 'Ose Benson',
        image: luke,
        star:3,
        description:
            'Let NuCamp be your guide to this off-the-beaten-path, hike-in-only campground.',
        position: 'Game Player'
    },
    {
        id: 8,
        author: 'Ina Ire',
        image: johnDoe,
        star:2,
        description:
            'Let NuCamp be your guide to this off-the-beaten-path, hike-in-only campground.',
        position: 'Baby Sitter'
    }
];
